/**
 * 用户端  专利检索
 */
 <template>
    <div class="login-page">
      <topInfo></topInfo>
      <cusNav></cusNav>
      <!-- 主体内容 -->
      <div class="eval-content" style="margin-bottom: 40px;">
         <div class="eval-con-top">
            <div class="eval-con-title"><span style="font-weight: 700;">丨</span>评估记录</div>
         </div>
         <div style="display: flex;margin: 0px 40px;">
            <el-input v-model="patentNumber" type="text" placeholder="请输入专利申请号，例：CN202411438730.X" clearable></el-input>
            <el-button class="eval-record-btn" title="输入申请号查询专利信息" @click="commitSearch()">检索</el-button>
            <!-- <el-button class="eval-record-btn" @click="refreshData()">刷新</el-button> -->
         </div>
         <!-- 筛选查询 -->
         <!-- <div style="display: flex;margin-top: 10px;">
            <el-button class="eval-record-btn">刷新</el-button>
            <el-button class="eval-record-btn">查询</el-button>
         </div> -->
         <div class="title-flex-end" style="margin-top: 10px;margin-right: 40px;">
               <!-- <div class="eval-con-btn">批量下载</div> -->
               <div class="areaPicker" style="margin-right: 10px;">
                     <span style="color: #606266;font-size: 14px;">评估时间：</span>
                     <el-date-picker
                           v-model="caseDate"
                           type="daterange"
                           range-separator="-"
                           start-placeholder="开始时间"
                           end-placeholder="结束时间"
                           format="yyyy.MM.dd"
                           value-format="yyyy-MM-dd"
                           :picker-options="pickerOptions">
                  </el-date-picker>
                  <span class="clearBtn" style="margin-left: 4px;" title="清除时间" @click="clearDate()">清除</span>
                  <span class="clearBtn" style="margin-left: 4px;" title="按照专利权人分组" @click="jumpChart()">图表统计</span>
                  <span class="clearBtn" style="margin-left: 4px;" @click="importCaseEval()">表格导出</span>
               </div>
               <div class="eval-con-search">
                  <el-input v-model="formInline.search" clearable placeholder="请输入关键词">
                     <el-button slot="append" style="color: #ffffff;" @click="getEvalOrderData()">搜索</el-button>
                  </el-input>
               </div>
         </div>
         <div style="margin: 10px 40px;">
            <el-table size="small" :data="recordData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" class="eval_table" style="width: 100%;" @selection-change="handleSelectionChange">
               <el-table-column align="center" type="selection" width="40" fixed="left">
               </el-table-column>
               <el-table-column align="center" type="index" label="序号" width="60">
               </el-table-column>
               <el-table-column prop="title" align="center" label="专利名称" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="appNumber" align="center" label="专利申请号" width="130" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="documentNumber" align="center" label="公告号" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="type" align="center" label="专利类型" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="patentee" align="center" label="专利权人" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="priceInt" align="center" label="专利价值(元)" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="levelt" align="center" label="评估结果" width="80" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="report_time" align="center" label="评估时间" show-overflow-tooltip>
               </el-table-column>
               <el-table-column align="center" label="操作" show-overflow-tooltip>
                  <template slot-scope="scope">
                     <el-button size="mini" style="background-color: #2A91DD;" type="primary" @click="downloadReport(scope.row)">查看报告</el-button>
                  </template>
               </el-table-column>
            </el-table>
         </div>
         <div style="margin: 0px 30px;padding-bottom: 30px;">
            <!-- 分页组件 -->
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
         </div>
         <!-- 查询结果弹窗 -->
         <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="patentResultVisible" width="700px">
            <div class="tt-header">查询结果</div>
            <div class="jzpgSeach_content_title">
               <div class="content_title_tag"></div>
               <div class="content_title_text">专利基本信息</div>
            </div>
            <div class="content_table">
               <div class="content_table_item">
                  <div class="content_table_left">专利名称：</div>
                  <div class="content_table_right" v-html="searchPatentData.title"></div>
               </div>
               <div class="content_table_item">
                  <div class="content_table_left">公开（公告）号：</div>
                  <div class="content_table_right" style="width: 180px;">{{ searchPatentData.documentNumber }}</div>
                  <div class="content_table_left">公开（公告）日：</div>
                  <div class="content_table_right" style="width: 180px;">{{ searchPatentData.documentDate }}</div>
               </div>
               <div class="content_table_item">
                  <div class="content_table_left">申请号：</div>
                  <div class="content_table_right" style="width: 180px;">{{ searchPatentData.applicationNumber }}</div>
                  <div class="content_table_left">申请日：</div>
                  <div class="content_table_right" style="width: 180px;">{{ searchPatentData.applicationDate }}</div>
               </div>
               <div class="content_table_item">
                  <div class="content_table_left">申请人：</div>
                  <div class="content_table_right">{{ searchPatentData.applicant }}</div>
               </div>
               <div class="content_table_item">
                  <div class="content_table_left">申请人地址：</div>
                  <div class="content_table_right">{{ searchPatentData.address }}</div>
               </div>
               <div class="content_table_item">
                  <div class="content_table_left">发明人：</div>
                  <div class="content_table_right">{{ searchPatentData.inventor }}</div>
               </div>
               <div class="content_table_item">
                  <div class="content_table_left">专利权人：</div>
                  <div class="content_table_right">{{ searchPatentData.assignee }}</div>
               </div>
               <div class="content_table_item">
                  <div class="content_table_left">当前专利权人：</div>
                  <div class="content_table_right">{{ searchPatentData.currentAssignee }}</div>
               </div>
               <div class="content_table_item">
                  <div class="content_table_left">主分类号：</div>
                  <div class="content_table_right" style="width: 180px;">{{ searchPatentData.mainIpc }}</div>
                  <div class="content_table_left">IPC分类号：</div>
                  <div class="content_table_right" style="width: 180px;">{{ searchPatentData.ipc }}</div>
               </div>
               <div class="content_table_item">
                  <div class="content_table_left">摘要：</div>
                  <div class="content_table_right">{{ searchPatentData.summary }}</div>
               </div>
            </div>
            <div class="zpgSeach_content_footer">
               <div>专利状态：{{ searchPatentData.status }}</div>
               <div v-if="searchPatentData.status=='有效' && !searchPatentData.isReport" class="footer_btn" @click="createReportOrder()">立即评估</div>
               <div v-if="searchPatentData.status=='有效' && searchPatentData.isReport" class="footer_btn" @click="viewReport()">查看报告</div>
            </div>
         </el-dialog>
         <!-- 订单确认弹窗 -->
         <el-dialog :close-on-click-modal="false" :visible.sync="orderConfirmVisible" width="770px">
            <div style="margin-top: -30px;">
               <div style="display: flex;align-items: center;">
               <img style="width: 60px;height: 60px;margin-right: 20px;" src="../../assets/eval/pay_head.png">
               <div style="height: 60px;display: flex;flex-direction: column;">
                  <div style="font-weight: 700;font-size: 18px;color: #333;line-height: 30px;margin-bottom: 10px;text-align: left;">支付界面</div>
                  <div style="font-size: 14px;color: #999;line-height: 20px;">请完善您的订单信息</div>
               </div>
            </div>
            <div class="pay_title">
               <div class="pay_title_bg"></div>
               <div>订单详情</div>
            </div>
            <div class="pay_order">
               <div class="pay_order_th">
                  <div style="width: 142px;">项目</div>
                  <div style="flex: 1;">专利申请号</div>
                  <div style="width: 66px;text-align: right;">金额</div>
               </div>
               <div class="pay_order_tr">
                  <div style="text-align: center;width: 142px;">专利价值评估</div>
                  <div style="flex: 1;">{{ searchPatentData.documentNumber }}</div>
                  <div style="width: 66px;text-align: right;">{{ unitPrice }}</div>
               </div>
               <div class="order_count">
                  <div style="font-size: 14px;">合计</div>
                  <div style="font-size: 16px;color: #ff4242;">￥{{ unitPrice }}</div>
               </div>
            </div>
            <div class="pay_title">
               <div class="pay_title_bg"></div>
               <div>支付方式</div>
            </div>
            <div class="pay_type_box">
               <div class="pay_type_item">
                  <el-checkbox v-model="orderForm.pay_type" :true-label="2" :false-label="0" style="width: 187px;padding: 0 20px;align-items: center;height: 50px;justify-content: space-between;line-height: 50px;">
                     <div class="type_item-right" style="font-size: 14px;margin-left: 10px;">
                        <img style="width: 14px;margin-right: 4px;" src="../../assets/eval/pay_zhifubao.png">支付宝支付
                     </div>
                  </el-checkbox>
               </div>
               <div class="pay_type_item">
                  <el-checkbox v-model="orderForm.pay_type" :true-label="1" :false-label="0" disabled style="width: 187px;padding: 0 20px;align-items: center;height: 50px;justify-content: space-between;line-height: 50px;">
                     <div class="type_item-right" style="font-size: 14px;margin-left: 10px;">
                        <img style="width: 14px;margin-right: 4px;" src="../../assets/eval/pay_weixi.png">微信支付
                     </div>
                  </el-checkbox>
               </div>
               <div class="pay_type_jf">
                  积分余额：{{ userPoints }}
               </div>
               <el-checkbox v-model="orderForm.is_use_points" :true-label="2" :false-label="1">优先使用积分</el-checkbox>
            </div>
            <div class="pay_btn">
               <el-button style="color: #fff;background-color: #2A91DD;padding: 10px 20px;border-radius: 4px;cursor: pointer;" @click="commitReportOrder()">前往支付</el-button>
            </div>
            </div>
         </el-dialog>
         <!-- 积分支付确认 -->
         <el-dialog :close-on-click-modal="false" :visible.sync="pointsPayConfirmVisible" width="400px">
            <div class="pay_price" style="height: 300px">
               <div style="font-size: 16px;color: #333;font-weight: 700;margin-top: -10px;">订单支付</div>
               <div style="margin-top: 10px;margin-bottom: 20px;">积分全额抵扣</div>
               <div>消耗积分</div>
               <!-- <div>{{ orderResult.points }}</div> -->
               <div style="color: #ff2c2c;font-size: 16px;margin-top: 4px;">{{ orderResult.deduction_fee }}</div>
               <div style="margin-top: 20px;">抵扣金额</div>
               <!-- <div>￥{{ orderResult.deduction_fee }}</div> -->
               <div style="color: #b9b9b9;text-decoration: line-through;margin-top: 4px;">￥{{ orderResult.deduction_fee }}</div>
               <div class="pay_btn">
                  <el-button style="color: #fff;background-color: #2A91DD;padding: 10px 20px;border-radius: 4px;cursor: pointer;" @click="orderPayUsePoints()">积分支付</el-button>
               </div>
            </div>
         </el-dialog>
         <!-- 扫码支付确认 -->
         <el-dialog :close-on-click-modal="false" :visible.sync="codePayConfirmVisible">
            
         </el-dialog>
          
      </div>
    </div>
 </template>
 <script>
   import topInfo from '../../components/topInfo'
   import cusNav from '../../components/cusNav'
   import '../../assets/js/directive'
   import { 
      searchReportPatent,
      getOrderConfig,
      getUserInfo,
      createReportOrderByOne,
      orderPayByPoints,
      getEvalOrderPageList,
      getEvalReport,
      exportCheckEvalData
   } from '../../api/evalMG'
   import { checkLogin } from '../../utils/util'
   import Pagination from '../../components/Pagination'
   export default {
      data() {
         return {
            loading: false,
            patentResultVisible: false,
            orderConfirmVisible: false,
            pointsPayConfirmVisible: false,
            codePayConfirmVisible: false,
            title: '',
            searchNav: '',
            setHeader:{
               'token': localStorage.getItem('userToken')
            },
            recordData: [],
            searchPatentData: [],
            patentNumber: '',
            loading: false,
            formInline: {
               page: 1,
               ps: 10,
               search: '',
               startDate: '',
               endDate: ''
            },
            unitPrice: 0,// 评估单价
            userPoints: 0,// 用户积分
            orderForm: {
               total_fee: 0,
               is_use_points: 0,
               pay_type: 0,
               documentNumber: ''
            },
            // 订单结果数据
            orderResult: [],
            caseDate: [],
            pickerOptions: {
               shortcuts: [{
               text: '最近一周',
               onClick(picker) {
               const end = new Date();
               const start = new Date();
               start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
               picker.$emit('pick', [start, end]);
               }
            }, {
               text: '最近一个月',
               onClick(picker) {
               const end = new Date();
               const start = new Date();
               start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
               picker.$emit('pick', [start, end]);
               }
            }, {
               text: '最近三个月',
               onClick(picker) {
               const end = new Date();
               const start = new Date();
               start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
               picker.$emit('pick', [start, end]);
               }
            }]
            },
            multipleSelection: [], //列表勾选框值
            // 分页参数
            pageparm: {
               currentPage: 1,
               pageSize: 10,
               total: 10
            }
        }
      },
       // 注册组件
      components: {
         Pagination,
         topInfo,
         cusNav
      },
      created(){
         this.getEvalOrderData()
      },
      // 监听
      watch: {

      },
      mounted(){
         
      },
      methods: {
         // 提交查询
         commitSearch(){
            if(this.patentNumber.length <= 0){
               this.$message.warning('请输入专利申请号!');
               return false;
            }
            let param = {
               applyNumber: this.patentNumber,
            }
            searchReportPatent(param)
            .then(res=>{
               if(res.code == 200){
                  this.searchPatentData = res.data
                  this.patentResultVisible = true
               }else{
                  this.$message.warning(res.msg);
               }
            })
         },
         // 创建评估订单,
         createReportOrder(){
            this.getOrderConfigData()
            this.getUserInfoData()
            setTimeout(()=>{
               this.orderConfirmVisible = true
               this.orderForm.pay_type = ''
               this.orderForm.is_use_points = ''
               this.orderForm.total_fee = ''
               this.orderForm.documentNumber = this.searchPatentData.documentNumber
               },1500)
         },
         // 获取订单配置数据
         getOrderConfigData(){
            getOrderConfig({})
            .then(res=>{
               if(res.code == 200){
                  this.unitPrice = res.data.evaluate_fee
               }
            })
         },
         // 获取用户积分数据
         getUserInfoData(){
            getUserInfo({})
            .then(res=>{
               if(res.code == 200){
                  this.userPoints = res.data.points
               }
            })
         },
         // 提交订单数据
         commitReportOrder(){
            this.orderForm.total_fee = this.unitPrice
            createReportOrderByOne(this.orderForm)
            .then(res=>{
               if(res.code == 200){
                  // 判断是否积分全额抵扣
                  // 下单成功
                  this.$message({
                    type: 'success',
                    message: res.msg
                 })
                 this.orderResult = res.data
                 if(res.data.total_fee > 0){
                     // 支付金额大于0,显示支付二维码
                     this.codePayConfirmVisible = true
                 }else{
                     // 积分全额抵扣,显示积分支付确认页
                     this.pointsPayConfirmVisible = true
                 }
               }else{
                  this.$message.warning(res.msg);
               }
            })
            console.log(this.orderForm)
         },
         // 积分支付确认
         orderPayUsePoints(){
            let order_sn = this.orderResult.order_sn
            if(order_sn.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '订单号不存在!'
               })
               return false
            }
            let param = { order_sn }
            orderPayByPoints(param)
            .then(res=>{
               if(res.code == 200){
                  this.$message({
                     type: 'success',
                     message: res.msg
                  })
                  this.pointsPayConfirmVisible = false
                  this.orderConfirmVisible = false
                  // 支付成功,生成评估报告
                  
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  })
               }
            })
         },
         // 查询价值评估订单数据
         getEvalOrderData(){
            this.loading = true
            let caseDate = this.caseDate
            if(caseDate&&caseDate.length>0){
               this.formInline.startDate = caseDate[0]
               this.formInline.endDate = caseDate[1]
            }else{
               this.formInline.startDate = ''
               this.formInline.endDate = ''
            }
            getEvalOrderPageList(this.formInline)
            .then(res=>{
               res = checkLogin(res);
                if(!res){
                 this.$message({
                   type: 'warning',
                   message: '登录已失效,请重新登录!'
                 }) 
                  // 登陆已失效 清除登陆状态
                  setTimeout(() => {
                     window.localStorage.removeItem('userToken');
                     window.localStorage.removeItem('sign');
                     window.localStorage.removeItem('userData');
                     this.$router.push({ path: '/login'});
                     }, 1000)
                }
               if(res.code == 200){
                  this.recordData = res.data.dataList
                  this.pageparm.currentPage = this.formInline.page
                  this.pageparm.pageSize = this.formInline.ps
                  this.pageparm.total = res.data.total
                  this.loading = false
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  }) 
               }
            })
         },
         // 刷新列表
         refreshData(){
            this.getEvalOrderData()
         },
         // 查看报告
         viewReport(){
            let pubNumber = this.searchPatentData.documentNumber
            getEvalReport({pubNumber: pubNumber})
            .then(res=>{
               if(res.code == 200){
                  window.open(res.data.report_url)
               }else{
                  this.$message.warning(res.msg);
               }
            })
         },
         // 查看报告(列表)
         downloadReport(row){
            let url = row.report_url
            if(url.length <= 0){
               this.$message.warning('报告生成中!');
               return false
            }
            window.open(url)
         },
         // 清除案件订单日期
         clearDate(){
            this.caseDate = []
         },
         // 跳转图表统计
         jumpChart(){
            let {href} =  this.$router.resolve('/client/platformChart')
            window.open(href,'_blank')
         },
         // 监听数据列表复选框是否选择
         handleSelectionChange(val){
            this.multipleSelection = val;
         },
         // 表格导出
         importCaseEval(){
            let checkIds = this.multipleSelection
            if(checkIds.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '暂无勾选的数据!'
               })
               return false
            }
            this.$confirm('确定导出勾选的记录吗?', '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
               type: 'warning'
            })
            .then(()=>{
               let idArr = []
               checkIds.forEach((item,index)=>{
                  idArr.push(item.id)
               })
               let ids = JSON.stringify(idArr)
               exportCheckEvalData({ids})
               .then(res=>{
                  if(res.code == 200){
                     this.$message({
                        type: 'success',
                        message: res.msg
                     })
                     window.location.href = res.data.url
                  }else{
                     this.$message({
                        type: 'error',
                        message: res.msg
                     })
                  }
               })
            })
            .catch(() => {
               this.$message({
                  type: 'info',
                  message: '已取消'
               })
            })
         },
         // 分页插件事件
         callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.ps = parm.pageSize
            this.getEvalOrderData()
         },
      }
   }
</script>
<style scoped>
  .login-page {
    text-align: center;
    /* height: 100%; */
  }
  .eval-content {
   width: 1200px;
   /* height: 600px; */
   margin: 0px auto;
   background-color: #fff;
   border-radius: 10px;
  }
  .eval-con-top {
   display: flex;
   margin: 20px 40px;
   padding: 16px 0px;
   border-bottom: 2px solid #eeeeee;
  }
  .eval-con-title {
   color: #2A91DD;
   height: 36px;
   line-height: 36px;
   font-size: 16px;
   font-weight: 700;
  }
  .eval_table>>>th {
   background: #2a99dd;
   font-size: 14px;
   color: #fff;
   font-weight: 400;
  }
  .eval-record-btn {
   margin-left: 20px;
   background-color: #2A91DD;
   color: #ffffff;
  }
  .tt-header {
   padding-top: 30px;
   font-weight: 700;
   font-size: 20px;
   color: #333;
   line-height: 23px;
   margin-top: -40px;
  }
  .jzpgSeach_content_title {
   display: flex;
   align-items: center;
   margin-bottom: 20px;
  }
  .jzpgSeach_content_title .content_title_tag {
   width: 10px;
   height: 23px;
   background: #2A91DD;
   border-radius: 4px;
   margin-right: 13px;
  }
  .jzpgSeach_content_title .content_title_text {
   font-weight: 700;
   font-size: 18px;
   color: #000;
  }
  .content_table {
   background: #f7f7fa;
   display: flex;
   border-top: 1px solid #e2e2e2;
   border-right: 1px solid #e2e2e2;
   flex-direction: column;
  }
  .content_table .content_table_item{
   display: flex;
   border-bottom: 1px solid #e2e2e2;
   width: 100%;
   color: #333;
  }
  .content_table .content_table_left {
   display: flex;
   width: 124px;
   flex-shrink: 0;
   align-items: center;
   justify-content: center;
   border-left: 1px solid #e2e2e2;
   border-right: 1px solid #e2e2e2;
  }
  .content_table .content_table_right {
   display: flex;
   align-items: center;
   padding: 10px;
   word-break: break-all;
   text-align: left;
  }
  .zpgSeach_content_footer {
   display: flex;
   align-items: center;
   justify-content: space-between;
   margin-top: 30px;
   font-weight: 400;
   font-size: 14px;
   color: #333;
  }
  .zpgSeach_content_footer .footer_btn {
   font-weight: 400;
   font-size: 14px;
   color: #fff;
   width: 182px;
   border-radius: 34px;
   height: 40px;
   box-shadow: 0 5px 10px #cec7e0a8;
   background-color: #2A91DD;
   line-height: 40px;
   cursor: pointer;
  }
  .pay_order_th {
   display: flex;
   align-items: center;
   padding: 0 20px;
   background: #efefef;
   border-radius: 4px;
   font-size: 14px;
   color: #333;
   height: 32px;
 }
 .pay_order {
   padding: 20px;
   width: 690px;
   background: #fff;
   box-shadow: 0 5px 10px #cec7e0a8;
   border-radius: 10px;
 }
 .pay_order_tr {
   display: flex;
   align-items: center;
   padding: 0 20px;
   font-size: 14px;
   color: #333;
   height: 47px;
   border-bottom: 1px solid #efefef;
 }
 .order_count {
   border-top: 1px solid #bdbdbd;
   display: flex;
   align-items: center;
   justify-content: space-between;
   padding: 10px 20px;
 }
  .pay_title {
   display: flex;
   font-size: 16px;
   margin-top: 30px;
   margin-bottom: 20px;
   color: #333;
 }
 .pay_title_bg {
   width: 10px;
   height: 23px;
   background-color: #2A91DD;
   border-radius: 4px;
   margin-right: 13px;
 }
 .pay_type_box {
   padding: 24px 20px;
   width: 690px;
   background: #fff;
   box-shadow: 0 5px 10px #cec7e0a8;
   border-radius: 10px;
   display: flex;
   align-items: center;
 }
 .pay_type_item {
   display: flex;
    width: 187px;
    height: 50px;
    border-radius: 10px;
    border: 1px solid #eee;
    margin-right: 20px;
 }
 .pay_type_jf {
   flex: 1;
   height: 50px;
   line-height: 50px;
   text-align: center;
   font-size: 14px;
   color: #333;
 }
 .pay_btn {
   margin-top: 30px;
   display: flex;
   justify-content: flex-end;
 }
 .pay_price {
   display: flex;
   flex-direction: column;
   align-items: center;
   padding-top: 30px;
   height: 400px;
 }
 .title-flex-end {
   display: flex;
   justify-content: flex-end;
   margin-left: auto;
 }
 .areaPicker {
   margin-top: 2px;
   margin-right: 20px;
 }
 .areaPicker>>>.el-input__inner {
    width: 210px !important;
    height: 40px !important;
    line-height: 40px !important;
    margin-top: -4px !important;
    padding-top: 3px !important;
    padding-bottom: 3px !important;
    padding-left: 20px !important;
    padding-right: 0px !important;
}
.areaPicker>>>i {
    display: none !important;
}
.areaPicker>>>.el-date-editor .el-range-separator {
    line-height: 30px !important;
    color: #999999 !important;
}
.clearBtn {
   padding: 12px 10px;
   border: 1px solid #2A91DD;
   border-radius: 4px;
   color: #ffffff;
   background-color: #2A91DD;
   font-size: 12px;
   cursor: pointer;
}
.eval-con-search>>>.el-input-group {
   border-radius: 10px !important;
  }
.eval-con-search>>>.el-input-group__append, .el-input-group__prepend {
   color: #FFFFFF;
   background-color: #2A91DD;
   cursor: pointer;
}
.eval-con-search>>>.el-input__inner {
   background-color: #F3F3F3 !important;
   border: none;
}
</style>


// WEBPACK FOOTER //
// src/views/client/evalRecord.vue